import CustomerDisplay from './CustomerDisplay';

const Customer = (props) => {
  const { reservationCart, customer, currentStep, onEdit } = props;
  if (currentStep === 'customer') {
    return null;
  }
  const handleEdit = (e) => {
    e.preventDefault();
    onEdit('customer');
  };
  if (currentStep === 'payment' || currentStep === 'complete') {
    return (
      <>
        <div>
          <div>
            <div>Contact information</div>
            <div>
              <CustomerDisplay
                reservationCart={reservationCart}
                customer={customer}
              />
            </div>
          </div>
          <a onClick={handleEdit}>Edit</a>
        </div>
        {reservationCart.notes &&
          renderNotes(reservationCart.notes, handleEdit)}
      </>
    );
  }
  return null;
};

const renderNotes = (notes, handleEdit) => (
  <div>
    <div>
      <div>Notes or dietary restrictions</div>
      <div>{notes}</div>
    </div>
    <a onClick={handleEdit}>Edit</a>
  </div>
);

export default Customer;
